<template>
    <div class="crm-main-cont">
        <a-tabs :defaultActiveKey="1" @change="callback">
            <a-tab-pane tab="待审核" :key="1">
                <a-spin tip="Loading..." :spinning="spinning">
                    <div class="search-box">
                        <a-form :form="formSearch" layout="inline">
                            <a-form-item label="产品名称:">
                                <a-input
                                        v-decorator="['proname1', ]"
                                />
                            </a-form-item>
                            <a-form-item label="所属机构:">
                                <a-input
                                        v-decorator="['servebank1', ]"
                                />
                            </a-form-item>


                        </a-form>
                    </div>
                    <div class="btns-group">
                        <a-button @click="searchConfirm" type="primary" style=" margin-top: 26px;">搜索</a-button>
                        <a-button @click="backConfirm">重置</a-button>
                    </div>
                    <a-table
                            rowKey="id"
                            bordered
                            :dataSource="listNot"
                            :pagination="pagination"
                            @change="change"
                            :columns="columns"
                    >
                        <template slot="operation" slot-scope="text, record">
                            <a @click="show(record)"
                            >查看明细&nbsp;&nbsp;&nbsp;</a
                            >
                            <a @click="check(record)">审核&nbsp;&nbsp;&nbsp;</a>
                        </template>
                    </a-table>
                </a-spin>
            </a-tab-pane>
            <a-tab-pane tab="已审核" :key="2">
                <a-spin tip="Loading..." :spinning="spinning">
                    <div class="search-box">
                        <a-form :form="formSearch1" layout="inline">
                            <a-form-item label="产品名称:">
                                <a-input
                                        v-decorator="['proname2', ]"
                                />
                            </a-form-item>
                            <a-form-item label="所属机构:">
                                <a-input
                                        v-decorator="['servebank2', ]"
                                />
                            </a-form-item>


                        </a-form>
                    </div>
                    <div class="btns-group">
                        <a-button @click="searchConfirm1" type="primary" style=" margin-top: 26px;">搜索</a-button>
                        <a-button @click="backConfirm1">重置</a-button>
                    </div>
                    <a-table
                            rowKey="id"
                            bordered
                            :dataSource="listAlready"
                            :pagination="pagination2"
                            @change="change2"
                            :columns="columns"
                    >
                        <template slot="operation" slot-scope="text, record">
                            <a @click="show(record)"
                            >查看明细&nbsp;&nbsp;&nbsp;</a
                            >
                            <a @click="showModal(record)"
                            >审核记录&nbsp;&nbsp;&nbsp;</a
                            >
                            <a-popconfirm
                                    title="是否要删除该条?"
                                    ok-text="是"
                                    cancel-text="否"
                                    @confirm="deleteClick(record.id)"
                            >
                                <a href="#">删除&nbsp;&nbsp;&nbsp;</a>
                            </a-popconfirm>
                        </template>
                    </a-table>
                </a-spin>
            </a-tab-pane>
        </a-tabs>

        <a-drawer
                title="查看产品明细"
                :width="700"
                @close="onClose"
                :visible="hide"
        >
            <a-descriptions
                    bordered
                    :column="2"
            >
                <a-descriptions-item label="产品名称">
                    {{ showItem.proname }}
                </a-descriptions-item>
                <a-descriptions-item label="适用对象">
                    {{ showItem.type }}
                </a-descriptions-item>
                <a-descriptions-item label="担保方式" v-if="!(showItem.product_type === '担保产品' || showItem.product_type === '保险产品')">
                    {{ showItem.guarantee }}
                </a-descriptions-item>
                <a-descriptions-item label="审批模式">
                    {{ showItem.approval_model }}
                </a-descriptions-item>
                <a-descriptions-item label="是否政策性产品">
                    {{ showItem.policy }}
                </a-descriptions-item>
                <a-descriptions-item label="产品类型">
                    {{ showItem.product_type }}
                </a-descriptions-item>
                <a-descriptions-item :label="loanText">
                    {{ showItem.loanMin }}~{{ showItem.loanMax }}万元
                </a-descriptions-item>
                <a-descriptions-item :label="loanDeadlineText">
                    {{ showItem.loanDeadlineMin }}~{{ showItem.loanDeadlineMax }}个月
                </a-descriptions-item>
                <a-descriptions-item :label="rateText">
                    <div v-if="showItem.rateMin == 0 && showItem.rateMax != 0">
                        不高于{{ showItem.rateMax }}%
                    </div>
                    <div v-else-if="showItem.rateMin != 0 && showItem.rateMax == 0">
                        {{ showItem.rateMin }}%起
                    </div>
                    <div v-else-if="showItem.rateMin == 0 && showItem.rateMax == 0">
                        面议
                    </div>
                    <div v-else>
                        {{ showItem.rateMin }}~{{ showItem.rateMax }}%
                    </div>
                </a-descriptions-item>
                <a-descriptions-item label="服务区域">
                    {{ showItem.region }}
                </a-descriptions-item>
                <a-descriptions-item label="还款方式" v-if="!(showItem.product_type === '担保产品' || showItem.product_type === '保险产品')">
                    {{ showItem.repayment_mode }}
                </a-descriptions-item>
                <a-descriptions-item label="审批时间">
                    <div v-if="showItem.approvalMin ==0 && showItem.approvalMax == 0">
                        秒申秒贷
                    </div>
                    <div v-else>
                        {{ showItem.approvalMin }}~{{ showItem.approvalMax }}个工作日
                    </div>
                </a-descriptions-item>
              <a-descriptions-item label="特色专区" :span="2">
                {{showItem.specialArea?showItem.specialArea:'不限'}}
              </a-descriptions-item>
                <a-descriptions-item label="产品简介" :span="2">
                    <p v-html="showItem.introduction"></p>
                </a-descriptions-item>
                <a-descriptions-item label="准入条件" :span="2">
                    <p v-html="showItem.access_conditions"></p>
                </a-descriptions-item>
                <a-descriptions-item label="产品特点" :span="2">
                    <p v-html="showItem.product_feature"></p>
                </a-descriptions-item>
                <a-descriptions-item label="适用群体" :span="2">
                    <p v-html="showItem.apply_group"></p>
                </a-descriptions-item>
                <a-descriptions-item label="相关费用" :span="2">
                    <p v-html="showItem.cost"></p>
                </a-descriptions-item>
                <a-descriptions-item label="所需材料" :span="2">
                    <p v-html="showItem.materials"></p>
                </a-descriptions-item>
                <a-descriptions-item label="提交时间">
                    {{showItem.updatedat}}
                </a-descriptions-item>
                <a-descriptions-item label="提交人">
                    {{showItem.loginname}}
                </a-descriptions-item>
            </a-descriptions>

        </a-drawer>

        <a-drawer
                title="审核意见"
                :width="650"
                @close="onClose2"
                :visible="hide2"
        >
            <a-descriptions
                    bordered
                    :column="2"
            >
                <a-descriptions-item label="产品名称">
                    {{ showItem.proname }}
                </a-descriptions-item>
                <a-descriptions-item label="适用对象">
                    {{ showItem.type }}
                </a-descriptions-item>
                <a-descriptions-item label="担保方式" v-if="!(showItem.product_type === '担保产品' || showItem.product_type === '保险产品')">
                    {{ showItem.guarantee }}
                </a-descriptions-item>
                <a-descriptions-item label="审批模式">
                    {{ showItem.approval_model }}
                </a-descriptions-item>
                <a-descriptions-item label="是否政策性产品">
                    {{ showItem.policy }}
                </a-descriptions-item>
                <a-descriptions-item label="产品类型">
                    {{ showItem.product_type }}
                </a-descriptions-item>
                <a-descriptions-item :label="loanText">
                    {{ showItem.loanMin }}~{{ showItem.loanMax }}万元
                </a-descriptions-item>
                <a-descriptions-item :label="loanDeadlineText">
                    {{ showItem.loanDeadlineMin }}~{{ showItem.loanDeadlineMax }}个月
                </a-descriptions-item>
                <a-descriptions-item :label="rateText">
                    {{ showItem.rateMin }}~{{ showItem.rateMax }}%
                </a-descriptions-item>
                <a-descriptions-item label="服务区域">
                    {{ showItem.region }}
                </a-descriptions-item>
                <a-descriptions-item label="还款方式" v-if="!(showItem.product_type === '担保产品' || showItem.product_type === '保险产品')">
                    {{ showItem.repayment_mode }}
                </a-descriptions-item>
                <a-descriptions-item label="审批时间">
                    {{ showItem.approvalMin }}~{{ showItem.approvalMax }}个工作日
                </a-descriptions-item>
              <a-descriptions-item label="特色专区" :span="2">
                {{showItem.specialArea?showItem.specialArea:'不限'}}
              </a-descriptions-item>
                <a-descriptions-item label="产品简介" :span="2">
                    <p v-html="showItem.introduction"></p>
                </a-descriptions-item>
                <a-descriptions-item label="准入条件" :span="2">
                    <p v-html="showItem.access_conditions"></p>
                </a-descriptions-item>
                <a-descriptions-item label="产品特点" :span="2">
                    <p v-html="showItem.product_feature"></p>
                </a-descriptions-item>
                <a-descriptions-item label="适用群体" :span="2">
                    <p v-html="showItem.apply_group"></p>
                </a-descriptions-item>
                <a-descriptions-item label="相关费用" :span="2">
                    <p v-html="showItem.cost"></p>
                </a-descriptions-item>
                <a-descriptions-item label="所需材料" :span="2">
                    <p v-html="showItem.materials"></p>
                </a-descriptions-item>
            </a-descriptions>
            <a-form :form="formOpinion" layout="vertical">
                <a-row :gutter="16">
                    <a-col :span="18">
                        <a-form-item label="审核意见">
                            <a-textarea placeholder="请填写审核意见" :rows="4"
                                        v-decorator="[
                                    'bcyj',{
                  rules: [{ required: true, message: '请填写审核意见' }
                                ]}]"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="快速录入审核意见">
                            <a-select
                                    v-decorator="['shidea']"
                                    placeholder="快速录入审核意见"
                                    @change="handleSelectChange">
                                <a-select-option
                                        :key="org.indexId"
                                        v-for="org in options"
                                        :value="org.indexId">
                                    {{ org.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>

                <div
                        :style="{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right'
                    }"
                >
                    <a-button :style="{ marginRight: '8px' }" @click="unagree"
                    >不同意
                    </a-button
                    >
                    <a-button @click="agree" type="primary">同意</a-button>
                </div>
            </a-form>
        </a-drawer>

        <a-spin tip="Loading..." :spinning="spinning">
            <a-modal v-model="visible" title="审核记录" onOk="handleOk">
                <template slot="footer">
                    <a-button key="submit" type="primary" @click="handleOk">
                        确定
                    </a-button>
                </template>
                <a-table
                        rowKey="id"
                        bordered
                        :dataSource="listRecord"
                        :pagination="pagination"
                        @change="change"
                        :columns="columnsRecord"
                ></a-table>
            </a-modal>
        </a-spin>
    </div>
</template>

<script>
    import axios from "axios";
    import {Listyy, check, checkPro, mySelect, deleteReviewed, getTypes} from "../../api/ajax";

    const columns = [
        {
            title: "产品名称",
            dataIndex: "proname",
            key: "proname",

        },
        {
            title: "所属机构",
            dataIndex: "logindept",
            key: "logindept"
        },
        {
            title: "提交时间",
            dataIndex: "updatedat",
            key: "updatedat"
        },
        {
            title: "提交人",
            dataIndex: "loginname",
            key: "loginname"
        },
        {
            title: "操作",
            dataIndex: "operation",
            scopedSlots: {customRender: "operation"}
        }
    ];
    const columnsRecord = [
        {
            title: "审核时间",
            dataIndex: "shtime",
            width: "30%"
        },
        {
            title: "审核人",
            dataIndex: "shpeople",
            key: "shpeople"
        },
        {
            title: "审核意见",
            dataIndex: "shidea",
            key: "shidea"
        }
    ];
    export default {
        data() {
            return {
                spinning: false,
                columns,
                columnsRecord,
                showItem: "",
                proname1: "",
                servebank1: "",
                proname2: "",
                servebank2: "",
                formSearch: this.$form.createForm(this),
                formSearch1: this.$form.createForm(this),
                form: this.$form.createForm(this),
                formOpinion: this.$form.createForm(this),
                hide: false,
                hide2: false,
                visible: false,
                confirmLoading: false,
                listAlready: [],
                listNot: [],
                options: [],
                listRecord: [],
              specialAreaList:[],
                shstate: 1,
                loanText:"贷款额度",
                loanDeadlineText:"贷款期限",
                rateText:"利率",
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: 0
                },
                pagination2: {
                    current: 1,
                    pageSize: 10,
                    total: 0
                }
            };
        },
        //列表显示
        beforeRouteEnter(to, from, next) {
            axios
                .all([Listyy(1, 1), mySelect()])
                .then(res => {
                    next(vm => {
                      vm.getAreaType();
                        if (res[0].data.success === "TRUE") {
                            vm.listNot = res[0].data.data.page.list;
                            vm.pagination = {
                                current: res[0].data.data.page.pageNum,
                                pageSize: res[0].data.data.page.pageSize,
                                total: res[0].data.data.page.total
                            };
                        }
                        vm.options = res[1].data.data.page;
                    });
                })
                .catch(() => {
                    next(vm => {
                        vm.$message.error("服务器出错！请稍后再试!");
                        vm.$Progress.fail();
                    });
                });
        },
        methods: {
            deleteClick(id) {
                deleteReviewed(id).then(resp => {
                    if (resp.data.success == "TRUE") {
                        this.$message.success("删除成功")
                        this.initList();
                    } else {
                        this.$message.error(resp.data.message);
                    }
                }).catch(() => this.$message.error("系统异常，请稍后再试！"))
            },
            onClose() {
                this.hide = false;
            },
            onClose2() {
                this.formOpinion.resetFields();
                this.hide2 = false;
            },
            show(data) {
                this.hide = true;
                this.showItem = data;
                if(data.product_type === "担保产品"){
                    this.loanText = "担保额度";
                    this.loanDeadlineText = "担保期限";
                    this.rateText = "利率";
                }else if(data.product_type === "保险产品"){
                    this.loanText = "保险额度";
                    this.loanDeadlineText = "承保期限";
                    this.rateText = "保费费率";
                }else {
                    this.loanText = "贷款额度";
                    this.loanDeadlineText = "贷款期限";
                    this.rateText = "利率";
                }
              this.$nextTick(()=>{
                let flag = data.specialArea != null && data.specialArea != undefined && data.specialArea != '' ;
                this.showItem.specialArea = flag ? this.specialAreaList.find(item => item.param === data.specialArea).desc : ''
              })
            },
            check(data) {
                this.hide2 = true;
                this.checkItem = data;
                this.showItem = data;
                if(data.product_type === "担保产品"){
                    this.loanText = "担保额度";
                    this.loanDeadlineText = "担保期限";
                    this.rateText = "利率";
                }else if(data.product_type === "保险产品"){
                    this.loanText = "保险额度";
                    this.loanDeadlineText = "承保期限";
                    this.rateText = "保费费率";
                }else {
                    this.loanText = "贷款额度";
                    this.loanDeadlineText = "贷款期限";
                    this.rateText = "利率";
                }
              this.$nextTick(()=>{
                let flag = data.specialArea != null && data.specialArea != undefined && data.specialArea != '' ;
                this.showItem.specialArea = flag ? this.specialAreaList.find(item => item.param === data.specialArea).desc : ''
              })
            },
            //切换tab 赋值状态
            callback(key) {
                this.shstate = key;
                this.initList();
            },
            //分页切换
            change(page) {
                this.pagination.current = page.current;
                this.initList();
                this.spinning = false;
            },
            change2(page) {
                this.pagination2.current = page.current;
                this.initList();
                this.spinning = false;
            },
            initList() {
                this.spinning = true;
                var proName = "";
                var servebank = "";
                if (this.shstate === 1) {
                    proName = this.proname1;
                    servebank = this.servebank1;
                } else {
                    proName = this.proname2;
                    servebank = this.servebank2;
                }
                if (this.shstate === 1) {
                    Listyy(this.pagination.current, this.shstate, proName, servebank).then(res => {
                        if (res.data.success === "TRUE") {
                            this.spinning = false;
                            this.listNot = res.data.data.page.list;
                            this.pagination = {
                                current: res.data.data.page.pageNum,
                                pageSize: res.data.data.page.pageSize,
                                total: res.data.data.page.total
                            };

                        }
                    });
                } else {
                    Listyy(this.pagination2.current, this.shstate, proName, servebank).then(res => {
                        if (res.data.success === "TRUE") {
                            this.spinning = false;
                            this.listAlready = res.data.data.page.list;
                            this.pagination2 = {
                                current: res.data.data.page.pageNum,
                                pageSize: res.data.data.page.pageSize,
                                total: res.data.data.page.total
                            };

                        }
                    });

                }
            },
            //审核同意
            agree() {
                this.formOpinion.validateFields((err, value) => {
                    if (!err) {
                        let shstate = 1,
                            proid = this.checkItem.id,
                            shidea = value.bcyj,
                            loginid = this.checkItem.loginid,
                            loginname = this.checkItem.loginname;
                        check(proid, shidea, shstate, loginid, loginname)
                            .then(res => {
                                if (res.data.success === "TRUE") {
                                    this.onClose2();
                                    this.initList();
                                    this.$message.success("审核同意！");
                                } else {
                                    this.$message.error(res.data.message);
                                }
                            })
                            .catch(() => {
                                this.$message.error("审核失败，请重试！");
                            });
                    }
                });
            },
            //审核未同意
            unagree() {
                this.formOpinion.validateFields((err, value) => {
                    if (!err) {
                        let shstate = 2,
                            proid = this.checkItem.id,
                            shidea = value.bcyj,
                            loginid = this.checkItem.loginid,
                            loginname = this.checkItem.loginname;
                        check(proid, shidea, shstate, loginid, loginname)
                            .then(res => {
                                if (res.data.success === "TRUE") {
                                    this.onClose2();
                                    this.initList();
                                    this.$message.success("审核不同意！");
                                } else {
                                    this.$message.error(res.data.message);
                                }
                            })
                            .catch(() => {
                                this.$message.error("审核失败，请重试！");
                            });
                    }
                });
            },
          // 特色专区字典
          getAreaType() {
            getTypes("003010").then(res => {
              this.$ajaxAfter(res).then(() => {
                this.specialAreaList = res.data.data.list;
              });
            }).catch(() => {
              this.$message.error("服务器出错！请稍后再试!");
            });
          },
            //审核时间转换
            formatDate(dates) {
                dates = new Date(dates);
                let date = {
                    year: dates.getFullYear(),
                    month:
                        dates.getMonth() + 1 < 10
                            ? "0" + (dates.getMonth() + 1)
                            : dates.getMonth() + 1,
                    day:
                        dates.getDate() < 10
                            ? "0" + dates.getDate()
                            : dates.getDate(),
                    hour:
                        dates.getHours() < 10
                            ? "0" + dates.getHours()
                            : dates.getHours(),
                    minute:
                        dates.getMinutes() < 10
                            ? "0" + dates.getMinutes()
                            : dates.getMinutes(),
                    second:
                        dates.getSeconds() < 10
                            ? "0" + dates.getSeconds()
                            : dates.getSeconds()
                };
                return (
                    date.year +
                    "-" +
                    date.month +
                    "-" +
                    date.day +
                    " " +
                    date.hour +
                    ":" +
                    date.minute +
                    ":" +
                    date.second
                );
            },
            //审核列表
            showModal(data) {
                checkPro(data.id, this.pagination.current).then(res => {
                    if (res.data.success === "TRUE") {
                        res.data.data.page.list.map(item => {
                            item.shtime = this.formatDate(item.shtime);
                        });
                        this.listRecord = res.data.data.page.list;
                        this.pagination = {
                            current: res.data.data.page.pageNum,
                            pageSize: res.data.data.page.pageSize,
                            total: res.data.data.page.total
                        };
                    }
                }),
                    (this.visible = true);
            },
            searchConfirm() {
                this.formSearch.validateFields((err, values) => {
                    if (!err) {
                        var proname = ""
                        var servebank = ""
                        if (values.proname1 != null) {
                            proname = values.proname1;
                            this.proname1 = values.proname1;
                        } else {
                            proname = "";
                            this.proname1 = "";
                        }
                        if (values.servebank1 != null) {
                            servebank = values.servebank1;
                            this.servebank1 = values.servebank1;
                        } else {
                            servebank = "";
                            this.servebank1 = "";
                        }
                        Listyy(1, 1, proname, servebank).then(res => {
                            if (res.data.success === "TRUE") {
                                this.listNot = res.data.data.page.list;
                                this.pagination = {
                                    current: res.data.data.page.pageNum,
                                    pageSize: res.data.data.page.pageSize,
                                    total: res.data.data.page.total
                                };
                            }
                        }).catch(() => {
                            this.$message.error("查询失败，请重试")
                        })

                    }
                })
            },
            backConfirm() {
                this.formSearch.resetFields();
                this.proname1 = "";
                this.servebank1 = "";
                this.shstate = 1;
                this.initList();
            },
            searchConfirm1() {
                this.formSearch1.validateFields((err, values) => {
                    if (!err) {
                        var proname = ""
                        var servebank = ""
                        if (values.proname2 != null) {
                            proname = values.proname2;
                            this.proname2 = values.proname2;
                        } else {
                            proname = "";
                            this.proname2 = "";
                        }
                        if (values.servebank2 != null) {
                            servebank = values.servebank2;
                            this.servebank2 = values.servebank2;
                        } else {
                            servebank = "";
                            this.servebank2 = "";
                        }
                        Listyy(1, 2, proname, servebank).then(res => {
                            if (res.data.success === "TRUE") {
                                this.listAlready = res.data.data.page.list;
                                this.pagination2 = {
                                    current: res.data.data.page.pageNum,
                                    pageSize: res.data.data.page.pageSize,
                                    total: res.data.data.page.total
                                };
                            }

                        }).catch(() => {
                            this.$message.error("查询失败，请重试")
                        })

                    }
                })
            },
            backConfirm1() {
                this.formSearch1.resetFields();
                this.proname2 = "";
                this.servebank2 = "";
                this.shstate = 2;
                this.initList();
            },
            handleOk() {
                this.visible = false;
            },
            handleSelectChange(value) {
                let str = value;
                if (this.formOpinion.getFieldsValue().bcyj != null && this.formOpinion.getFieldsValue().bcyj != "undefined") {
                    let str1 = this.formOpinion.getFieldsValue().bcyj;
                    str1 = str1 + str;
                    this.formOpinion.setFieldsValue({
                        bcyj: str1

                    });
                } else {
                    this.formOpinion.setFieldsValue({
                        bcyj: str

                    });
                }


            },
        }
    };
</script>
<style scoped lang="less">
    .search-box {
        .ant-form-item {
            display: inline-block;
            min-width: 280px;
        }

        .ant-select {
            width: 169px;
        }
    }

    .btns-group button {
        margin-right: 10px;
        margin-top: 24px;
        margin-bottom: 20px;
    }

    /deep/ .ant-descriptions-item-label {
        width: 20%;
    }
    /deep/ .ant-tabs-nav .ant-tabs-tab{
        font-size: 16px;
    }
    /deep/ .ant-tabs-nav .ant-tabs-tab-active{
        font-size: 16px;
    }
</style>
